var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3228(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.168,
    height: 90,
    viewBox: "0 0 90.168 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228",
    transform: "translate(627.147 -185.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M-608.6,285.434c-9.761-10.193-7.626-23.448-.032-30.6a20.949,20.949,0,0,1,29.026.012c7.633,7.237,9.66,20.469-.019,30.569a34.117,34.117,0,0,1,13.469,12.155,32.782,32.782,0,0,1,5.073,17.445h-66.058a32.024,32.024,0,0,1,4.96-17.31A33.59,33.59,0,0,1-608.6,285.434Zm-11.92,23.6h52.8c-2.629-9.448-8.318-15.9-17.35-19.34a3.24,3.24,0,0,0-1.968.193,21.578,21.578,0,0,1-14.148.012,3.269,3.269,0,0,0-1.969-.218C-612.176,293.119-617.92,299.526-620.524,309.029Zm26.448-23.946A15.059,15.059,0,0,0-579.1,270a15.055,15.055,0,0,0-15.087-14.97,15.05,15.05,0,0,0-14.97,15.083A15.058,15.058,0,0,0-594.076,285.083Z",
    transform: "translate(0 -39.877)",
    fill: "#6b344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M-506.393,226.866l-1.392-5.76c5.131-.863,9.234-3.284,11.742-7.975a13.978,13.978,0,0,0,1.619-9.062c-1.218-7.267-6.869-12.518-13.779-12.937-7.951-.481-13.16,3.832-16.151,13.454l-5.388-1.283c-.639-4.362,4.311-13.159,11.964-16.416a21.076,21.076,0,0,1,25.336,6.7c5.448,7.3,6.425,18.649-2.337,27.877,11.669,6.389,17.966,16.143,18.589,29.612-.674.053-1.156.122-1.637.122-7.76.007-15.52.036-23.279-.042a4.069,4.069,0,0,1-2.343-1.053c-1.637-1.411-3.145-2.973-5.113-4.866h25.631A27.329,27.329,0,0,0-496.158,227.6c-2.551-1.5-5.1-2.563-8.076-1.138A8.463,8.463,0,0,1-506.393,226.866Z",
    transform: "translate(-60.789 0)",
    fill: "#6b344a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3228);
export default __webpack_public_path__ + "static/media/Group 3228.b228c1c28036899adb363c99adc3df3a.svg";
export { ForwardRef as ReactComponent };